import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import CourseCard from "../courseCard";
import {
  getCourses,
  addCourse,
  deleteCourse,
  updateCourse,
} from "../../../helper/apicalls/course";
import "./../../../styles/admin/courses.scss";
import GlobalLoader from "../../common/GlobalLoader";
import Cookies from "js-cookie";

const EvalHome = () => {
  const navigate = useNavigate();
  const { setIsShowHeader, setHeaderName, setIsShowSearch } =
    useOutletContext();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = Cookies.get("role");

  const fetchCourses = async () => {
    try {
      setLoading(true);
      const data = await getCourses();

      if (role === "institution" || role === "teacher") {
        const normalized = Array.isArray(data)
          ? data.flatMap((item) => item?.course || [])
          : [];
        setCourses(normalized);
      } else {
        setCourses(data || []);
      }
    } catch (error) {
      console.error("Failed to fetch courses:", error);
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredCourses = courses.filter((course) => {
    const name = (course && course.name) || "";
    return name.toLowerCase();
  });

  useEffect(() => {
    setHeaderName("Eval");
  }, [setHeaderName]);

  useEffect(() => {
    setIsShowSearch(true);
    fetchCourses();
  }, []);

  return (
    <div className="courses-container">
      <GlobalLoader visible={loading} text="Loading evals..." />
      <div className="courses-grid">
        {filteredCourses?.length > 0 &&
          filteredCourses?.map((course) => (
            <div key={course.id}>
              <CourseCard
                course={course}
                onEdit={undefined}
                onDelete={undefined}
                fetchCourses={fetchCourses}
                hideActionBtn={true}
                handleNavigate={() => {
                  navigate(`/admin/eval/${course.key}`);
                }}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default EvalHome;
